const STORE_DETAIL = {
  name: "Floristería Honduras",
  street: "Col Trejo 26 avenida 11 y12 calle Casa N. 1127",
  city: "San Pedro Sula",
  department: "Cortés",
  phone: "+504 8732-4880"
};

export { STORE_DETAIL };
